import * as z from "zod";

/** Legal structure of the business, collected for KYC. Mirrors the three
 * values Gale documents today; `privateCompany` is the default. */
export const galeKycOrganizationTypeSchema = z.enum([
  "privateCompany",
  "partnership",
  "unincorporatedPartnership",
]);
export type GaleKycOrganizationType = z.infer<
  typeof galeKycOrganizationTypeSchema
>;

export const galeKycRegisteredAddressSchema = z.object({
  line1: z.string().min(1),
  line2: z.string().optional(),
  city: z.string().min(1),
  state: z.string().min(1),
  postalCode: z.string().min(1),
  country: z.string().min(1),
});

/** The Gale KYC business-details payload: the one wire-and-storage shape used
 * by the admin SDK, the merchant conversion SDK, and the persisted record. */
export const galeKycFieldsSchema = z.object({
  legalName: z.string().min(1),
  ein: z.string().min(1),
  registeredAddress: galeKycRegisteredAddressSchema,
  statementDescriptor: z.string().min(1),
  phoneNumber: z.string().min(1),
  webAddress: z.string().min(1),
  doingBusinessAs: z.string().optional(),
  organizationType: galeKycOrganizationTypeSchema.optional(),
  registrationNumber: z.string().optional(),
  supportEmail: z.string().optional(),
  supportPhone: z.string().optional(),
  returnUrl: z.string().optional(),
});
export type GaleKycFields = z.infer<typeof galeKycFieldsSchema>;

/** A team's saved billing address, used to prefill the registered address on
 * a first fill-out. Null when the team has no address on file. */
export const galeKycAddressDefaultsSchema = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  city: z.string(),
  state: z.string().optional(),
  postalCode: z.string(),
});
